import ZoneAbattagesFormController from './zone.abattages.form.controller';

export default {
    template: require('./zone.abattages.form.html'),
    controller: ZoneAbattagesFormController
};
